import type { BankState } from '@klopotun/contracts';
import { queryOptions } from '@tanstack/react-query';
import { bankQueryRoot } from '../../../../shared/api/index.js';
import { getBankState } from '../requests/get-bank-state.js';

const SYNC_REFRESH_MS = 60_000;

const isStillLoadingHistory = (state: BankState | undefined): boolean =>
  state?.connection?.accounts.some((account) => account.isTracked && !account.isHistoryComplete) ??
  false;

export const bankQueries = {
  ...bankQueryRoot,
  state: () =>
    queryOptions({
      queryKey: [...bankQueryRoot.all(), 'state'] as const,
      queryFn: ({ signal }) => getBankState(signal),
      refetchInterval: (query) =>
        isStillLoadingHistory(query.state.data) ? SYNC_REFRESH_MS : false,
    }),
};
